if (!customElements.get('mme-reviews')) {
  customElements.define(
    'mme-reviews',
    class MmeReviews extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mme-reviews');
        this.slides = Array.from(this.querySelectorAll('.mme-review'));
        this.currentOutput = this.querySelector('[data-review-current]');
        this.previousButton = this.querySelector('[data-review-previous]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = Number(this.dataset.speed) || 6000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.track || this.slides.length < 2) return;

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.updateCurrent(), { passive: true });

        ['mouseenter', 'focusin', 'pointerdown', 'touchstart'].forEach((eventName) => {
          this.addEventListener(eventName, () => this.stop());
        });
        ['mouseleave', 'focusout'].forEach((eventName) => {
          this.addEventListener(eventName, () => this.start());
        });

        this.start();
      }

      move(direction) {
        const current = this.getCurrentIndex();
        const target = (current + direction + this.slides.length) % this.slides.length;
        this.track.scrollTo({
          left: this.slides[target].offsetLeft - this.track.offsetLeft,
          behavior: this.reducedMotion ? 'auto' : 'smooth',
        });
      }

      getCurrentIndex() {
        const trackLeft = this.track.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      updateCurrent() {
        if (this.currentOutput) this.currentOutput.textContent = this.getCurrentIndex() + 1;
      }

      start() {
        if (!this.autoplay || this.reducedMotion || this.interval) return;
        this.interval = window.setInterval(() => this.move(1), this.speed);
      }

      stop() {
        window.clearInterval(this.interval);
        this.interval = null;
      }

      disconnectedCallback() {
        this.stop();
      }
    }
  );
}
